export const ACTIONS = {
  EXPORT_DATA_BICYCLES_FETCH_START: 'EXPORT_DATA_BICYCLES_FETCH_START',
  EXPORT_DATA_BICYCLES_FETCH_SUCCESS: 'EXPORT_DATA_BICYCLES_FETCH_SUCCESS',
  EXPORT_DATA_BICYCLES_FETCH_FAILURE: 'EXPORT_DATA_BICYCLES_FETCH_FAILURE',
  EXPORT_DATA_BICYCLES_FETCH_RESET: 'EXPORT_DATA_BICYCLES_FETCH_RESET',
};
